<template>
  <div class="min-h-screen font-sans transition-colors duration-300">
    <div
      class="bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-100"
    >
      <categories
        v-show="!productListVisible"
        @categoryClick="onCategoryClick"
      />
      <p-list v-show="productListVisible" :ptype="productType" />
    </div>
  </div>
</template>

<script>
import Categories from './Categories'
import pList from './pList'
export default {
  name: 'Products',
  components: {
    Categories,
    pList
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.path === '/products' && to.query.i === 'rK6w6tH26Z') {
          this.productListVisible = false
        } else if (to.query.i === 'btEHNsnQ') {
          // this.productListVisible = true
        }
      },
      deep: true, // 深度监听
      immediate: true // 立即执行一次
    }
  },
  data() {
    return {
      productListVisible: false,
      productType: null
    }
  },
  // created() {
  //   console.log('xxxxxxaaaaaaaaaaaxxxxx')
  // },
  methods: {
    onCategoryClick(data) {
      // console.log(JSON.stringify(data))
      this.productType = data.msg
      this.productListVisible = true
      this.updateQueryParam()
    },

    updateQueryParam() {
      const newUrl = new URL(window.location.href)
      newUrl.searchParams.set('i', 'btEHNsnQ') // 设置查询参数
      window.history.pushState({}, '', newUrl.href) // 更新URL但不重新加载页面
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/Products/Index.vue